import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { IFeedsConfigurationProvider, Module, Provider } from '@bciti/types';
import { takeUntil } from 'rxjs/operators';
import { RssProviderDialogComponent } from '../rss-provider-dialog/rss-provider-dialog.component';

@Component({
    selector: 'app-rss-provider-form',
    templateUrl: './rss-provider-form.component.html',
    styleUrls: ['./rss-provider-form.component.scss'],
})
export class RssProviderFormComponent implements OnInit {
    @Input() providerType!: Provider;
    @Input() providersForm: FormGroup;
    @Input() isLoading: boolean;

    constructor(public dialog: MatDialog) {}

    ngOnInit(): void {}

    get filteredProviders(): IFeedsConfigurationProvider[] {
        return this.providers.filter((i) => i.type === this.providerType);
    }

    removeProvider(provider: IFeedsConfigurationProvider) {
        this.providersForm.get('providers').setValue(this.providers.filter((i) => i.url !== provider.url || i.type !== provider.type));
    }

    addProvider() {
        const dialogRef = this.dialog.open(RssProviderDialogComponent, {
            width: '600px',
            data: {
                type: this.providerType,
            },
        });

        const sub = dialogRef.componentInstance.update.subscribe((r) => {
            this.providersForm.get('providers').setValue([...this.providers, r.new]);
        });

        dialogRef.afterClosed().subscribe(() => {
            sub.unsubscribe();
        });
    }

    checkProviderFeed(url: string) {}

    editProvider(provider: IFeedsConfigurationProvider) {
        const dialogRef = this.dialog.open(RssProviderDialogComponent, {
            width: '600px',
            data: provider,
        });

        const sub = dialogRef.componentInstance.update.subscribe((r) => {
            const updatedProviderList = this.providers.map((i) => {
                if (i.type === r.old.type && i.url === r.old.url) {
                    return r.new;
                }

                return i;
            });

            this.providersForm.get('providers').setValue(updatedProviderList);
        });

        dialogRef.afterClosed().subscribe(() => {
            sub.unsubscribe();
        });
    }

    get providers() {
        return this.providersForm.get('providers').value;
    }
}
